import { c as _c } from "react/compiler-runtime";
import { useState, useLayoutEffect } from 'react';
export const useWindowResize = onResize => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: 0,
      height: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [size, setSize] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== onResize) {
    t1 = () => {
      const handleResize = () => {
        const newValue = {
          width: window.innerWidth,
          height: window.innerHeight
        };
        setSize(newValue);
        onResize?.(newValue);
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    };
    t2 = [onResize];
    $[1] = onResize;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  return size;
};